export const PALETTE_MODE = {
    LIGHT: 'light',
    DARK: 'dark',
} as const;
